import OrganisationLogo from "../organisation-logo/organisation-logo";

import SVGRaindropLogoWithTitle from "../svg-raindrop-logo-with-title/svg-raindrop-logo-with-title";
import RaindropCircle from "../raindrop-circle/raindrop-circle.tsx";

const DateInfo = () => {
  return (
    <div className="flex flex-col absolute items-end self-end -translate-x-1 p-1 text-white">
      <div className="font-black">JAN.</div>
      <div className="font-bold -translate-y-2 text-sm ">2024</div>
    </div>
  );
};

const RaindropCircleShareable = ({
  id = "no-id-provided",
  values = [0, 0, 0, 0, 0, 0, 0, 0],
  featureIdx = 1,
  urlBackground = null,
  urlForeground = null,
  urlOrganisationLogo = "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/nimbus_organisation_martini.png",
}) => {
  const opacityNonFeature = "opacity-40";

  const opacityFeature = "opacity-70";

  const colorNonFeature = `stroke-white ${opacityNonFeature}`; // TODO: This should not be how it is done.

  const colorFeature = `stroke-white ${opacityFeature}`;

  const colors = values.map((value, i) => {
    if (i === featureIdx) {
      return colorFeature;
    }
    return colorNonFeature;
  });

  const size = "w-[250px] h-[250px]";

  values = [
    {
      value: 20,
      oldValue: 20,
      color: "stroke-color-raindrop-minor",
    },
    {
      value: 60,
      oldValue: 60,
      color: "stroke-color-raindrop-minor shadow-2xl shadow-black",
    },
    {
      value: 20,
      oldValue: 20,
      color: "stroke-color-raindrop-minor ",
    },
  ];
  return (
    <div
      className={`flex flex-col justify-start rounded-lg  items-center relative ${size} shadow-black shadow-2xl`}
      draggable={false}
    >
      <div class="absolute">
        <img
          src={urlBackground}
          alt="background"
          className="relative w-full h-full rounded-lg border border-color-dark-border-primary"
        />
      </div>

      <RaindropCircle
        id={"raindrop-circle-shareable-" + id}
        sausageValues={values}
        topCircleFill={`fill-white  ${opacityNonFeature}`}
        topCircleStroke={`stroke-white ${opacityNonFeature}`}
        colors={colors}
        size={size}
        showCenterPiece={false}
        showInnerCircle={false}
        isShowingDots={false}
      />

      <img
        src={urlForeground}
        alt="foreground"
        className="absolute w-full h-full"
      />

      <OrganisationLogo
        src={urlOrganisationLogo}
        additionalClasses={
          "absolute self-start translate-x-2 translate-y-2 w-8 h-8 "
        }
      />

      <DateInfo />

      <div className="flex flex-col absolute h-full justify-end w-full p-2">
        <SVGRaindropLogoWithTitle
          className={`self-end justify-items-end-end w-full fill-white opacity-70 h-3 `}
        />
      </div>
    </div>
  );
};

export default RaindropCircleShareable;
